import React, {ReactNode} from "react";

export function PageHeader({children}: { children?:ReactNode }) {
    return (
        <div className={'flex flex-col gap-4'}>
            {children}
        </div>
    )
}
